import { GridColumn } from 'types/grid';
import { ModalListData } from 'types/modal';
import { PromotionItem } from './index';

// 프로모션 그리드 컬럼 정의
export const promotionGridColumns: GridColumn[] = [
  { title: 'ID', key: 'id', width: 80 },
  { title: 'Title', key: 'title', width: 180 },
  { title: 'Description', key: 'description', width: 200 },
  { title: 'Notice', key: 'notice', width: 200 },
  { title: 'Active', key: 'isActive', width: 100 },
  { title: 'Start Date', key: 'startDate', width: 130 },
  { title: 'End Date', key: 'endDate', width: 130 },
  { title: 'Created', key: 'createdAt', width: 130 },
  { title: 'Actions', key: 'actions', width: 150 }
];

// 프로모션 상세 모달 리스트
export const promotionModalList: ModalListData[] = [
  { title: 'ID', key: 'id' },
  { title: 'Title', key: 'title' },
  { title: 'Description', key: 'description' },
  { title: 'Notice', key: 'notice' },
  { title: 'Active Status', key: 'isActive' },
  { title: 'Start Date', key: 'startDate' },
  { title: 'End Date', key: 'endDate' },
  { title: 'Banner Image URL', key: 'bannerImageUrl' },
  { title: 'Button Text', key: 'buttonText' },
  { title: 'Button Link', key: 'buttonLink' },
  { title: 'Created At', key: 'createdAt' },
  { title: 'Updated At', key: 'updatedAt' }
];

// 활성 상태 스타일 정의
export const activeStatus = {
  true: {
    title: 'Active',
    className: 'bg-green-100 text-green-800 border-green-200'
  },
  false: {
    title: 'Inactive', 
    className: 'bg-gray-100 text-gray-600 border-gray-200'
  }
};

// 날짜 포맷 유틸 (년-월-일 형식만)
export const formatDate = (dateString: string) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// 프로모션 유효성 검사
export const validatePromotion = (data: Partial<PromotionItem>) => {
  const errors: Record<string, string> = {};

  if (!data.title?.trim()) {
    errors.title = 'Title is required';
  }

  if (!data.description?.trim()) {
    errors.description = 'Description is required';
  }

  if (!data.notice?.trim()) {
    errors.notice = 'Notice is required';
  }

  if (!data.startDate) {
    errors.startDate = 'Start date is required';
  }

  if (!data.endDate) {
    errors.endDate = 'End date is required';
  }

  if (data.startDate && data.endDate && new Date(data.startDate) > new Date(data.endDate)) {
    errors.endDate = 'End date must be after or equal to start date';
  }

  // Button Text와 Button Link는 선택사항이므로 필수값 검사 제거

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};
